// File download utilities

import { saveAs } from 'file-saver';

/**
 * Download Excel file from API blob response
 * @param {Blob} blob - Response blob from API
 * @param {string} filename - Filename for download
 */
export const downloadExcelFile = (blob, filename) => {
  try {
    const excelBlob = new Blob([blob], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    });
    saveAs(excelBlob, filename);
  } catch (error) {
    console.error('Error downloading file:', error);
    throw new Error('Failed to download file');
  }
};

/**
 * Generate filename for transaction Excel download
 * @param {string} type - Transaction type (cash_sale, invoice, credit_note, refund)
 * @param {number|string} id - Transaction ID
 * @returns {string} Formatted filename
 */
export const generateTransactionFilename = (type, id) => {
  const typeNames = {
    cash_sale: 'Cash Sale',
    invoice: 'Invoice',
    credit_note: 'Credit Note',
    refund: 'Refund',
    quote: 'Quote'
  };

  const typeName = typeNames[type] || type;
  return `${typeName} ${id}.xlsx`;
};

/**
 * Download transaction Excel from API response
 * @param {Object} response - Axios response with blob data
 * @param {string} type - Transaction type
 * @param {number|string} id - Transaction ID
 */
export const downloadTransactionExcel = (response, type, id) => {
  const filename = generateTransactionFilename(type, id);
  downloadExcelFile(response.data, filename);
};
